import styled, { css } from 'styled-components';

const Price = styled.span`
  color: ${({ theme }) => theme.colors.night_blue_1};
  ${({ bold }) =>
    bold
      ? css`
          ${({ theme }) => theme.fontFamily.secondaryFont.mediumBold};
        `
      : css`
          ${({ theme }) => theme.fontFamily.secondaryFont.mediumRegular};
        `}
  ${({ image }) =>
    image
      ? css`
          max-width: 100%;
        `
      : css`
          max-width: 90%;
        `}
`;

export default Price;
